"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Loyalty = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 Z M12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 Z M12.0627058,7.1418994 C12.1783331,7.16661366 12.2686592,7.25693969 12.2933734,7.37256699 L12.8882195,10.1555933 L15.4349575,8.88547412 C15.5832266,8.81152874 15.7633671,8.87178007 15.8373125,9.02004922 C15.8900825,9.12585938 15.8757801,9.25279647 15.8007882,9.3442113 L13.995811,11.5444692 L16.5766953,12.7436828 C16.7269525,12.8135001 16.7921618,12.9919056 16.7223445,13.1421628 C16.6725204,13.2493916 16.5643596,13.3173535 16.4461319,13.3157187 L13.6005162,13.276369 L14.2720883,16.0418831 C14.3111867,16.2028892 14.212361,16.365106 14.0513548,16.4042044 C13.9364551,16.4321065 13.8158832,16.3899165 13.7434476,16.296463 L12,14.047137 L10.2565524,16.296463 C10.1550502,16.4274171 9.96660718,16.4512925 9.83565313,16.3497904 C9.74219965,16.2773548 9.7000097,16.1567828 9.72791173,16.0418831 L10.3994838,13.276369 L7.55386813,13.3157187 C7.38819854,13.3180096 7.25203966,13.185565 7.24969205,13.0198954 C7.24811389,12.9016677 7.31607582,12.7935069 7.42330467,12.7436828 L10.004189,11.5444692 L8.19921184,9.3442113 C8.09412744,9.21611396 8.11278312,9.02708281 8.24088046,8.92199841 C8.33229529,8.84700644 8.45923239,8.83270406 8.56504254,8.88547412 L11.1117805,10.1555933 L11.7066266,7.37256699 C11.741258,7.21054131 11.9006802,7.10726791 12.0627058,7.1418994 Z" })));
};
Loyalty.displayName = 'Loyalty';
exports.default = Loyalty;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Loyalty.js.map